import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RememberPasswordRoutingModule } from './remember-password-routing.module';
import { RememberPasswordComponent } from './remember-password.component';
import {ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [RememberPasswordComponent],
  imports: [
    CommonModule,
    RememberPasswordRoutingModule,
    ReactiveFormsModule
  ]
})
export class RememberPasswordModule { }
